import { render } from "./LinkageGeneralError.vue?vue&type=template&id=4800b242&scoped=true&ts=true"
import script from "./LinkageGeneralError.vue?vue&type=script&lang=ts"
export * from "./LinkageGeneralError.vue?vue&type=script&lang=ts"

import "./LinkageGeneralError.vue?vue&type=style&index=0&id=4800b242&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2728993903/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4800b242"]])

export default __exports__